var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.isStudent)?_c('evaluation-statistics-student'):_vm._e(),(_vm.isTeam)?_c('evaluation-statistics-team'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }